import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  step: 0
}

// sliceを生成
export const purchaseStep = createSlice({
  name: 'purchaseStep',
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload
    },
    stepIncrement: (state) => {
      state.step += 1
    },
    stepDecrement: (state) => {
      state.step -= 1
    },
    stepReset: (state) => {
      state.step = initialState.step
    }
  },
})

export const { stepIncrement, stepDecrement, stepReset, setStep } = purchaseStep.actions
export default purchaseStep.reducer
